import { HighlightedCode } from '../HighlightedCode';
import { inferLanguageFromPath } from './constants';

export function ToolPayloadView({ payload }: { payload: Record<string, unknown> }) {
  const codeKey = (['code', 'content', 'source', 'fileContent'] as const)
    .find(k => typeof payload[k] === 'string' && (payload[k] as string).length > 40);
  const pathKey = (['path', 'filename', 'file'] as const)
    .find(k => typeof payload[k] === 'string');

  if (!codeKey) {
    return (
      <HighlightedCode
        language="json"
        code={JSON.stringify(payload, null, 2)}
        className="tool-detail-json"
      />
    );
  }

  const code = payload[codeKey] as string;
  const path = pathKey ? (payload[pathKey] as string) : undefined;
  const rest: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(payload)) {
    if (k !== codeKey) rest[k] = v;
  }
  const restEntries = Object.entries(rest);
  const lang = inferLanguageFromPath(path);

  return (
    <div className="tool-payload-split">
      {restEntries.length > 0 && (
        <HighlightedCode
          language="json"
          code={JSON.stringify(rest, null, 2)}
          className="tool-detail-json tool-detail-meta"
        />
      )}
      <HighlightedCode
        code={code}
        language={lang}
        filename={path}
        className="tool-detail-code"
      />
    </div>
  );
}
